import {EUR_CURRENCY_SYMBOL} from "./generalConstants.js/generalConstants";
import {numberFormat} from "./moneyFormat";

export const decodeCurrencySymbol = symbol => {
  if (!symbol) return "";
  try {
    const normalized = symbol.replace(/\\u/g, "\\u");
    return JSON.parse(`"${normalized.replace(/"/g, '\\"')}"`);
  } catch (err) {
    return symbol;
  }
};

export const resolveCurrencyLabel = (currency, currencyIdFallback) => {
  const decoded = decodeCurrencySymbol(currency?.symbol);
  if (decoded) return decoded;
  if (currency?.shortName) return currency.shortName;

  switch (currencyIdFallback) {
    case 978:
      return "EUR";
    case 840:
      return "USD";
    case 980:
      return "UAH";
    default:
      return "";
  }
};

export const formatNumberWithCurrency = (value, currencyLabel = EUR_CURRENCY_SYMBOL, precision = 2) => {
  const hasValue = value != null && value !== "";
  if (!hasValue) return "";
  const num = numberFormat(value, precision);
  return `${currencyLabel} ${num}`;
};

export const formatNumberWithCurrencyV2 = (value, currency, precision = 2) => {
  const hasValue = value != null && value !== "";
  if (!hasValue) return "";

  const currencyLabel = !currency ? EUR_CURRENCY_SYMBOL : resolveCurrencyLabel(currency);
  const num = numberFormat(value, precision);
  return `${currencyLabel} ${num}`;
};
